export enum DigitalWalletType {
	NotSet = -1,
	ApplePay = 1
}
